import React from 'react'
import { Filters } from './components/Filters/Filters'
import { ProductGrid } from './components/Products'
import { FiltersProvider, ProductsProvider } from './context'

export const App: React.FC = () => (
  <FiltersProvider>
    <ProductsProvider>
      <Filters />
      <ProductGrid />
    </ProductsProvider>
  </FiltersProvider>
)
